import React, { memo } from "react";
import { Modal, ModalBody } from "reactstrap";
import { IoClose } from "react-icons/io5";

const ImagePreviewModal = ({ isOpen, toggle, imageSrc, alt = "Full Preview", zIndex = 10000 }) => {
  if (!imageSrc) return null;

  return (
    <Modal
      isOpen={isOpen}
      toggle={toggle}
      centered
      zIndex={zIndex}
      contentClassName="bg-transparent border-0"
    >
      <ModalBody className="p-0 d-flex justify-content-center align-items-center">
        <div className="position-relative" style={{ display: "inline-block", maxWidth: "100%" }}>
          <button
            type="button"
            className="cursor position-absolute border-0 d-flex align-items-center justify-content-center"
            style={{
              top: "12px",
              right: "12px",
              zIndex: 1001,
              background: "rgba(0, 0, 0, 0.65)",
              backdropFilter: "blur(4px)",
              borderRadius: "50%",
              width: "36px",
              height: "36px",
              color: "#FFFFFF",
              transition: "all 0.2s ease",
            }}
            onClick={toggle}
            aria-label="Close image preview"
          >
            <IoClose size={22} />
          </button>
          <img
            src={imageSrc}
            alt={alt}
            className="img-fluid"
            style={{
              maxHeight: "90vh",
              maxWidth: "100%",
              display: "block",
              borderRadius: "16px",
              boxShadow: "0 20px 50px rgba(0, 0, 0, 0.4)",
              objectFit: "contain",
            }}
            loading="lazy"
          />
        </div>
      </ModalBody>
    </Modal>
  );
};

export default memo(ImagePreviewModal);
